









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SimpleSlideToggleComponent extends Vue {
  @Prop()
  private value: boolean;

  @Prop()
  private changeEvent: string;

  updateValue() {
    this.$x.emit(this.changeEvent, !this.value);
  }
}
